function isAssignmentLTI(material) {
    return Boolean('assignment' in material && material.assignment && material.assignment.id);
}
function isScorableLti(material) {
    return Boolean('userMaxScore' in material && material.userMaxScore);
}

export { isAssignmentLTI, isScorableLti };
